// extracted by mini-css-extract-plugin
export var box = "category-hit-module--box--f1294";
export var container = "category-hit-module--container--48e46";
export var highlight = "category-hit-module--highlight--73023";
export var image = "category-hit-module--image--8b668";
export var imageContainer = "category-hit-module--imageContainer--7b0d0";
export var link = "category-hit-module--link--4d500";
export var snippet = "category-hit-module--snippet--eeeab";